import { Component, inject, computed, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Select } from '@openng/optimus-ui/select';

import { GroupFilterService, GroupOption } from 'src/app/services/group-filter.service';
import { DropdownOption } from 'src/app/models/dropdown-option.model';

@Component({
	selector: 'app-group-filter',
	imports: [FormsModule, Select],
	templateUrl: './group-filter.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrl: './group-filter.component.scss',
})
export class GroupFilterComponent {
	private groupFilterService = inject(GroupFilterService);

	readonly isResultsEnvironment = this.groupFilterService.isResultsEnvironment;

	readonly availableFunctionalGroups = this.groupFilterService.availableFunctionalGroups;

	readonly availableOrgGroups = this.groupFilterService.availableOrgGroups;

	private readonly ALL_FG: DropdownOption = { uid: null, name: 'All' };

	private readonly ALL_OG: DropdownOption = { uid: null, name: 'All' };

	readonly fgOptions = computed<DropdownOption[]>(() => [this.ALL_FG, ...this.availableFunctionalGroups()]);

	readonly ogOptions = computed<DropdownOption[]>(() => [this.ALL_OG, ...this.availableOrgGroups()]);

	public get selectedFg(): DropdownOption {
		return this.groupFilterService.selectedFunctionalGroup() ?? this.ALL_FG;
	}

	public set selectedFg(value: DropdownOption) {
		this.groupFilterService.selectFunctionalGroup(value.uid ? (value as GroupOption) : null);
	}

	public get selectedOg(): DropdownOption {
		return this.groupFilterService.selectedOrgGroup() ?? this.ALL_OG;
	}

	public set selectedOg(value: DropdownOption) {
		this.groupFilterService.selectOrgGroup(value.uid ? (value as GroupOption) : null);
	}
}
